//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions  } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './StudyRoutesClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type GetAllStudyRoutesQueryParameters = {
  studyId?: number | null;
};

export type GetStudyRouteByIdStudyRoutesQueryParameters = {
  id: string;
};

export type GetPatientRouteProgressStudyRoutesQueryParameters = {
  patientId: string;
};

    
export function getAllUrl(studyId?: number | undefined): string {
  let url_ = getBaseUrl() + "/api/studyRoutes";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getAllDefaultOptions: UseQueryOptions<Types.StudyRouteDto[], unknown, Types.StudyRouteDto[]> = {
  queryFn: __getAll,
};
export function getGetAllDefaultOptions(): UseQueryOptions<Types.StudyRouteDto[], unknown, Types.StudyRouteDto[]> {
  return getAllDefaultOptions;
};
export function setGetAllDefaultOptions(options: UseQueryOptions<Types.StudyRouteDto[], unknown, Types.StudyRouteDto[]>) {
  getAllDefaultOptions = options;
}

export function getAllQueryKey(studyId?: number | undefined): QueryKey;
export function getAllQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { studyId,  } = params[0] as GetAllStudyRoutesQueryParameters;

    return trimArrayEnd([
        'StudyRoutesClient',
        'getAll',
        studyId as any,
      ]);
  } else {
    return trimArrayEnd([
        'StudyRoutesClient',
        'getAll',
        ...params
      ]);
  }
}
function __getAll(context: QueryFunctionContext) {
  return Client.getAll(
      context.queryKey[2] as number | undefined    );
}

export function useGetAllQuery<TSelectData = Types.StudyRouteDto[], TError = unknown>(dto: GetAllStudyRoutesQueryParameters, options?: UseQueryOptions<Types.StudyRouteDto[], TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Get all study routes by study
 * @param studyId (optional) 
 */
export function useGetAllQuery<TSelectData = Types.StudyRouteDto[], TError = unknown>(studyId?: number | undefined, options?: UseQueryOptions<Types.StudyRouteDto[], TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetAllQuery<TSelectData = Types.StudyRouteDto[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.StudyRouteDto[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined;
  let studyId: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ studyId,  } = params[0] as GetAllStudyRoutesQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [studyId, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  if (axiosConfig) {
    options = options ?? { } as any;
    options!.meta = { ...options!.meta, axiosConfig };
  }

  return useQuery<Types.StudyRouteDto[], TError, TSelectData>({
    queryFn: __getAll,
    queryKey: getAllQueryKey(studyId),
    ...getAllDefaultOptions as unknown as UseQueryOptions<Types.StudyRouteDto[], TError, TSelectData>,
    ...options,
  });
}
/**
 * Get all study routes by study
 * @param studyId (optional) 
 */
export function setGetAllData(queryClient: QueryClient, updater: (data: Types.StudyRouteDto[] | undefined) => Types.StudyRouteDto[], studyId?: number | undefined) {
  queryClient.setQueryData(getAllQueryKey(studyId),
    updater
  );
}

/**
 * Get all study routes by study
 * @param studyId (optional) 
 */
export function setGetAllDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.StudyRouteDto[] | undefined) => Types.StudyRouteDto[]) {
  queryClient.setQueryData(queryKey, updater);
}
    
    
export function createStudyRouteUrl(): string {
  let url_ = getBaseUrl() + "/api/studyRoutes";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function createStudyRouteMutationKey(): MutationKey {
  return trimArrayEnd([
      'StudyRoutesClient',
      'createStudyRoute',
    ]);
}

/**
 * Create study route
 */
export function useCreateStudyRouteMutation<TContext>(options?: Omit<UseMutationOptions<Types.StudyRouteDto, unknown, Types.CreateStudyRouteDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.StudyRouteDto, unknown, Types.CreateStudyRouteDto, TContext> {
  const key = createStudyRouteMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation((dto: Types.CreateStudyRouteDto) => Client.createStudyRoute(dto), {...options, mutationKey: key});
}
  
    
export function getStudyRouteByIdUrl(id: string): string {
  let url_ = getBaseUrl() + "/api/studyRoutes/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getStudyRouteByIdDefaultOptions: UseQueryOptions<Types.StudyRouteDto, unknown, Types.StudyRouteDto> = {
  queryFn: __getStudyRouteById,
};
export function getGetStudyRouteByIdDefaultOptions(): UseQueryOptions<Types.StudyRouteDto, unknown, Types.StudyRouteDto> {
  return getStudyRouteByIdDefaultOptions;
};
export function setGetStudyRouteByIdDefaultOptions(options: UseQueryOptions<Types.StudyRouteDto, unknown, Types.StudyRouteDto>) {
  getStudyRouteByIdDefaultOptions = options;
}

export function getStudyRouteByIdQueryKey(id: string): QueryKey;
export function getStudyRouteByIdQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { id,  } = params[0] as GetStudyRouteByIdStudyRoutesQueryParameters;

    return trimArrayEnd([
        'StudyRoutesClient',
        'getStudyRouteById',
        id as any,
      ]);
  } else {
    return trimArrayEnd([
        'StudyRoutesClient',
        'getStudyRouteById',
        ...params
      ]);
  }
}
function __getStudyRouteById(context: QueryFunctionContext) {
  return Client.getStudyRouteById(
      context.queryKey[2] as string    );
}

export function useGetStudyRouteByIdQuery<TSelectData = Types.StudyRouteDto, TError = unknown>(dto: GetStudyRouteByIdStudyRoutesQueryParameters, options?: UseQueryOptions<Types.StudyRouteDto, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Get study route
 */
export function useGetStudyRouteByIdQuery<TSelectData = Types.StudyRouteDto, TError = unknown>(id: string, options?: UseQueryOptions<Types.StudyRouteDto, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetStudyRouteByIdQuery<TSelectData = Types.StudyRouteDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.StudyRouteDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined;
  let id: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ id,  } = params[0] as GetStudyRouteByIdStudyRoutesQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [id, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  if (axiosConfig) {
    options = options ?? { } as any;
    options!.meta = { ...options!.meta, axiosConfig };
  }

  return useQuery<Types.StudyRouteDto, TError, TSelectData>({
    queryFn: __getStudyRouteById,
    queryKey: getStudyRouteByIdQueryKey(id),
    ...getStudyRouteByIdDefaultOptions as unknown as UseQueryOptions<Types.StudyRouteDto, TError, TSelectData>,
    ...options,
  });
}
/**
 * Get study route
 */
export function setGetStudyRouteByIdData(queryClient: QueryClient, updater: (data: Types.StudyRouteDto | undefined) => Types.StudyRouteDto, id: string) {
  queryClient.setQueryData(getStudyRouteByIdQueryKey(id),
    updater
  );
}

/**
 * Get study route
 */
export function setGetStudyRouteByIdDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.StudyRouteDto | undefined) => Types.StudyRouteDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
    
export function openRouteProgressStepManuallyUrl(patientId: string): string {
  let url_ = getBaseUrl() + "/api/studyRoutes/{patientId}";
if (patientId === undefined || patientId === null)
  throw new Error("The parameter 'patientId' must be defined.");
url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function openRouteProgressStepManuallyMutationKey(patientId: string): MutationKey {
  return trimArrayEnd([
      'StudyRoutesClient',
      'openRouteProgressStepManually',
      patientId as any,
    ]);
}

/**
 * Re-open missed and finished forms (pipeline steps) for specific patient.
 * @param patientId Related patient id
 * @param dto DTO with new pipeline steps
 */
export function useOpenRouteProgressStepManuallyMutation<TContext>(patientId: string, options?: Omit<UseMutationOptions<void, unknown, Types.UpdatePatientRouteProgressDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.UpdatePatientRouteProgressDto, TContext> {
  const key = openRouteProgressStepManuallyMutationKey(patientId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation((dto: Types.UpdatePatientRouteProgressDto) => Client.openRouteProgressStepManually(patientId, dto), {...options, mutationKey: key});
}
  
    
export function addCheckpointToStudyRouteUrl(studyRouteId: string): string {
  let url_ = getBaseUrl() + "/api/studyRoutes/checkPoints/{studyRouteId}";
if (studyRouteId === undefined || studyRouteId === null)
  throw new Error("The parameter 'studyRouteId' must be defined.");
url_ = url_.replace("{studyRouteId}", encodeURIComponent("" + studyRouteId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function addCheckpointToStudyRouteMutationKey(studyRouteId: string): MutationKey {
  return trimArrayEnd([
      'StudyRoutesClient',
      'addCheckpointToStudyRoute',
      studyRouteId as any,
    ]);
}

/**
 * Add new checkpoint to study route
 * @param studyRouteId ID of the StudyRoute where the new checkpoint will be added
 * @param dto DTO with new checkpoint
 */
export function useAddCheckpointToStudyRouteMutation<TContext>(studyRouteId: string, options?: Omit<UseMutationOptions<void, unknown, Types.AddCheckpointDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.AddCheckpointDto, TContext> {
  const key = addCheckpointToStudyRouteMutationKey(studyRouteId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation((dto: Types.AddCheckpointDto) => Client.addCheckpointToStudyRoute(studyRouteId, dto), {...options, mutationKey: key});
}
  
    
export function addFormConfigToCheckpointUrl(studyRouteId?: string | undefined, checkpointName?: string | undefined): string {
  let url_ = getBaseUrl() + "/api/studyRoutes/formConfig?";
if (studyRouteId === null)
    throw new Error("The parameter 'studyRouteId' cannot be null.");
else if (studyRouteId !== undefined)
    url_ += "studyRouteId=" + encodeURIComponent("" + studyRouteId) + "&";
if (checkpointName === null)
    throw new Error("The parameter 'checkpointName' cannot be null.");
else if (checkpointName !== undefined)
    url_ += "checkpointName=" + encodeURIComponent("" + checkpointName) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function addFormConfigToCheckpointMutationKey(studyRouteId?: string | undefined, checkpointName?: string | undefined): MutationKey {
  return trimArrayEnd([
      'StudyRoutesClient',
      'addFormConfigToCheckpoint',
      studyRouteId as any,
      checkpointName as any,
    ]);
}

/**
 * Add new form config to study route
 * @param dto The form config dto to add
 * @param studyRouteId (optional) StudyRouteId to add form config
 * @param checkpointName (optional) The name of the Checkpoint where to add the form config
 */
export function useAddFormConfigToCheckpointMutation<TContext>(studyRouteId?: string | undefined, checkpointName?: string | undefined, options?: Omit<UseMutationOptions<void, unknown, Types.AddFormConfigToCheckpointDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.AddFormConfigToCheckpointDto, TContext> {
  const key = addFormConfigToCheckpointMutationKey(studyRouteId, checkpointName);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation((dto: Types.AddFormConfigToCheckpointDto) => Client.addFormConfigToCheckpoint(dto, studyRouteId, checkpointName), {...options, mutationKey: key});
}
  
    
export function getPatientRouteProgressUrl(patientId: string): string {
  let url_ = getBaseUrl() + "/api/studyRoutes/RouteProgress/OfPatient?";
  if (patientId === undefined || patientId === null)
    throw new Error("The parameter 'patientId' must be defined and cannot be null.");
  else
    url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getPatientRouteProgressDefaultOptions: UseQueryOptions<Types.RouteProgressDto, unknown, Types.RouteProgressDto> = {
  queryFn: __getPatientRouteProgress,
};
export function getGetPatientRouteProgressDefaultOptions(): UseQueryOptions<Types.RouteProgressDto, unknown, Types.RouteProgressDto> {
  return getPatientRouteProgressDefaultOptions;
};
export function setGetPatientRouteProgressDefaultOptions(options: UseQueryOptions<Types.RouteProgressDto, unknown, Types.RouteProgressDto>) {
  getPatientRouteProgressDefaultOptions = options;
}

export function getPatientRouteProgressQueryKey(patientId: string): QueryKey;
export function getPatientRouteProgressQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { patientId,  } = params[0] as GetPatientRouteProgressStudyRoutesQueryParameters;

    return trimArrayEnd([
        'StudyRoutesClient',
        'getPatientRouteProgress',
        patientId as any,
      ]);
  } else {
    return trimArrayEnd([
        'StudyRoutesClient',
        'getPatientRouteProgress',
        ...params
      ]);
  }
}
function __getPatientRouteProgress(context: QueryFunctionContext) {
  return Client.getPatientRouteProgress(
      context.queryKey[2] as string    );
}

export function useGetPatientRouteProgressQuery<TSelectData = Types.RouteProgressDto, TError = unknown>(dto: GetPatientRouteProgressStudyRoutesQueryParameters, options?: UseQueryOptions<Types.RouteProgressDto, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Get the route progress of the patient by id
 * @param patientId Id of the patient whose route progress is requested
 */
export function useGetPatientRouteProgressQuery<TSelectData = Types.RouteProgressDto, TError = unknown>(patientId: string, options?: UseQueryOptions<Types.RouteProgressDto, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetPatientRouteProgressQuery<TSelectData = Types.RouteProgressDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.RouteProgressDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined;
  let patientId: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ patientId,  } = params[0] as GetPatientRouteProgressStudyRoutesQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [patientId, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  if (axiosConfig) {
    options = options ?? { } as any;
    options!.meta = { ...options!.meta, axiosConfig };
  }

  return useQuery<Types.RouteProgressDto, TError, TSelectData>({
    queryFn: __getPatientRouteProgress,
    queryKey: getPatientRouteProgressQueryKey(patientId),
    ...getPatientRouteProgressDefaultOptions as unknown as UseQueryOptions<Types.RouteProgressDto, TError, TSelectData>,
    ...options,
  });
}
/**
 * Get the route progress of the patient by id
 * @param patientId Id of the patient whose route progress is requested
 */
export function setGetPatientRouteProgressData(queryClient: QueryClient, updater: (data: Types.RouteProgressDto | undefined) => Types.RouteProgressDto, patientId: string) {
  queryClient.setQueryData(getPatientRouteProgressQueryKey(patientId),
    updater
  );
}

/**
 * Get the route progress of the patient by id
 * @param patientId Id of the patient whose route progress is requested
 */
export function setGetPatientRouteProgressDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.RouteProgressDto | undefined) => Types.RouteProgressDto) {
  queryClient.setQueryData(queryKey, updater);
}